import { useEffect } from 'react'
import useLogout from '../app-services/useLogout'

function Logout() {
    const { logout } = useLogout()

    useEffect(() => {
        logout()
    }, [])

    return <></>
}

export default Logout
